import { ContractStateDto } from "../../../autogen/bff-api";
import { urls } from "../../../urls";

export const contractUrl = (contractId: string, contractState: ContractStateDto | null | undefined, eventId: string) =>
  contractState === ContractStateDto.Published
    ? urls.v2.contracts.view.go(contractId)
    : urls.contracts.edit.go(contractId, eventId).details;
